const cloudinaryEnv = (state = "") => {
  return state;
};

export default cloudinaryEnv;
